/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllowEditResponseDTO,
  CalcolaOreCommesseResponseDTO,
  CalcolaOreMancantiResponseDTO,
  CalcolaTotaleOreMensiliResponseDTO,
  CalendarioLavoriResponseDTO,
  CopiaLavoroMassivoRequestDTO,
  DuplicaGiornataRequestDTO,
  LavoriDettaglioResponseDTO,
  LavoriDettaglioSpeseResponseDTO,
  LavoriInsertDTO,
  LavoriResponseDTO,
  LavoriSpeseInsertDTO,
  ProblemDetails,
  ReportResponseDTO,
  SpesePrecedentiResponseDTO,
  TipiRimborsoResponseDTO,
} from '../models/index';
import {
    AllowEditResponseDTOFromJSON,
    AllowEditResponseDTOToJSON,
    CalcolaOreCommesseResponseDTOFromJSON,
    CalcolaOreCommesseResponseDTOToJSON,
    CalcolaOreMancantiResponseDTOFromJSON,
    CalcolaOreMancantiResponseDTOToJSON,
    CalcolaTotaleOreMensiliResponseDTOFromJSON,
    CalcolaTotaleOreMensiliResponseDTOToJSON,
    CalendarioLavoriResponseDTOFromJSON,
    CalendarioLavoriResponseDTOToJSON,
    CopiaLavoroMassivoRequestDTOFromJSON,
    CopiaLavoroMassivoRequestDTOToJSON,
    DuplicaGiornataRequestDTOFromJSON,
    DuplicaGiornataRequestDTOToJSON,
    LavoriDettaglioResponseDTOFromJSON,
    LavoriDettaglioResponseDTOToJSON,
    LavoriDettaglioSpeseResponseDTOFromJSON,
    LavoriDettaglioSpeseResponseDTOToJSON,
    LavoriInsertDTOFromJSON,
    LavoriInsertDTOToJSON,
    LavoriResponseDTOFromJSON,
    LavoriResponseDTOToJSON,
    LavoriSpeseInsertDTOFromJSON,
    LavoriSpeseInsertDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ReportResponseDTOFromJSON,
    ReportResponseDTOToJSON,
    SpesePrecedentiResponseDTOFromJSON,
    SpesePrecedentiResponseDTOToJSON,
    TipiRimborsoResponseDTOFromJSON,
    TipiRimborsoResponseDTOToJSON,
} from '../models/index';

export interface CalcolaOreCommesseRequest {
    idPersonale?: number;
    data?: Date;
}

export interface CalcolaOreMancantiRequest {
    idPersonale?: number;
    data?: Date;
}

export interface CalcolaTotaleOreMensiliRequest {
    idPersonale?: number;
    data?: Date;
}

export interface CopiaGiornoPrecedenteRequest {
    idPersonale?: number;
    data?: Date;
}

export interface CopiaLavoroMassivoRequest {
    copiaLavoroMassivoRequestDTO?: CopiaLavoroMassivoRequestDTO;
}

export interface DeleteAllegatoSpesaRequest {
    idFileAlegato?: number;
}

export interface DeleteLavoroRequest {
    id: number;
}

export interface DuplicaGiornataRequest {
    duplicaGiornataRequestDTO?: DuplicaGiornataRequestDTO;
}

export interface GetBloccoCaricamentoLavoriRequest {
    idPersonale?: number;
    data?: Date;
}

export interface GetCalendarioLavoriRequest {
    idPersonale?: number;
    data?: Date;
}

export interface GetFileSpesaByIdRequest {
    idFileAllegato?: number;
}

export interface GetLavoriRequest {
    daData?: Date;
    aData?: Date;
    personaleId?: number;
}

export interface GetLavoroByIdRequest {
    idLavoro: number;
}

export interface GetReportLavoratoMensileRequest {
    idPersonale?: number;
    data?: Date;
    idCliente?: number;
    idCommessa?: number;
}

export interface GetReportSpeseMensiliRequest {
    idPersonale?: number;
    data?: Date;
}

export interface GetSpeseByLavoroIdRequest {
    idLavoro?: number;
}

export interface SetGiornataSmartworkingRequest {
    idPersonale?: number;
    data?: Date;
}

export interface SpesePrecedentiRequest {
    idCommessa?: number;
    idPersonale?: number;
    idTipoSpesa?: number;
}

export interface UploadFileSpeseRequest {
    idLavoro?: number;
    idTipoSpesa?: number;
    file?: Blob;
}

export interface UpsertLavoroRequest {
    lavoriInsertDTO?: LavoriInsertDTO;
}

export interface UpsertSpeseRequest {
    idLavoro?: number;
    lavoriSpeseInsertDTO?: Array<LavoriSpeseInsertDTO>;
}

/**
 * 
 */
export class LavoriApi extends runtime.BaseAPI {

    /**
     */
    async calcolaOreCommesseRaw(requestParameters: CalcolaOreCommesseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalcolaOreCommesseResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/calcolaOreCommesse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CalcolaOreCommesseResponseDTOFromJSON));
    }

    /**
     */
    async calcolaOreCommesse(requestParameters: CalcolaOreCommesseRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalcolaOreCommesseResponseDTO>> {
        const response = await this.calcolaOreCommesseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async calcolaOreMancantiRaw(requestParameters: CalcolaOreMancantiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalcolaOreMancantiResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/calcolaOreMancanti`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CalcolaOreMancantiResponseDTOFromJSON));
    }

    /**
     */
    async calcolaOreMancanti(requestParameters: CalcolaOreMancantiRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalcolaOreMancantiResponseDTO>> {
        const response = await this.calcolaOreMancantiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async calcolaTotaleOreMensiliRaw(requestParameters: CalcolaTotaleOreMensiliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalcolaTotaleOreMensiliResponseDTO>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/calcolaTotaleOreMensili`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalcolaTotaleOreMensiliResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async calcolaTotaleOreMensili(requestParameters: CalcolaTotaleOreMensiliRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalcolaTotaleOreMensiliResponseDTO> {
        const response = await this.calcolaTotaleOreMensiliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async copiaGiornoPrecedenteRaw(requestParameters: CopiaGiornoPrecedenteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/copiaGiornoPrecedente`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async copiaGiornoPrecedente(requestParameters: CopiaGiornoPrecedenteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.copiaGiornoPrecedenteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async copiaLavoroMassivoRaw(requestParameters: CopiaLavoroMassivoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/CopiaLavoroMassivo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CopiaLavoroMassivoRequestDTOToJSON(requestParameters['copiaLavoroMassivoRequestDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async copiaLavoroMassivo(requestParameters: CopiaLavoroMassivoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.copiaLavoroMassivoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAllegatoSpesaRaw(requestParameters: DeleteAllegatoSpesaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['idFileAlegato'] != null) {
            queryParameters['idFileAlegato'] = requestParameters['idFileAlegato'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/deleteAllegatoSpesa`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAllegatoSpesa(requestParameters: DeleteAllegatoSpesaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAllegatoSpesaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteLavoroRaw(requestParameters: DeleteLavoroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteLavoro().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteLavoro(requestParameters: DeleteLavoroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLavoroRaw(requestParameters, initOverrides);
    }

    /**
     */
    async duplicaGiornataRaw(requestParameters: DuplicaGiornataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/DuplicaGiornata`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DuplicaGiornataRequestDTOToJSON(requestParameters['duplicaGiornataRequestDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async duplicaGiornata(requestParameters: DuplicaGiornataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.duplicaGiornataRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getBloccoCaricamentoLavoriRaw(requestParameters: GetBloccoCaricamentoLavoriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllowEditResponseDTO>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/bloccoCaricamentoLavori`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllowEditResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async getBloccoCaricamentoLavori(requestParameters: GetBloccoCaricamentoLavoriRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllowEditResponseDTO> {
        const response = await this.getBloccoCaricamentoLavoriRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCalendarioLavoriRaw(requestParameters: GetCalendarioLavoriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalendarioLavoriResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/calendarioLavori`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CalendarioLavoriResponseDTOFromJSON));
    }

    /**
     */
    async getCalendarioLavori(requestParameters: GetCalendarioLavoriRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalendarioLavoriResponseDTO>> {
        const response = await this.getCalendarioLavoriRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFileSpesaByIdRaw(requestParameters: GetFileSpesaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportResponseDTO>> {
        const queryParameters: any = {};

        if (requestParameters['idFileAllegato'] != null) {
            queryParameters['idFileAllegato'] = requestParameters['idFileAllegato'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/getFileSpesaById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async getFileSpesaById(requestParameters: GetFileSpesaByIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportResponseDTO> {
        const response = await this.getFileSpesaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLavoriRaw(requestParameters: GetLavoriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LavoriResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['daData'] != null) {
            queryParameters['daData'] = (requestParameters['daData'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['aData'] != null) {
            queryParameters['aData'] = (requestParameters['aData'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['personaleId'] != null) {
            queryParameters['personaleId'] = requestParameters['personaleId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LavoriResponseDTOFromJSON));
    }

    /**
     */
    async getLavori(requestParameters: GetLavoriRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LavoriResponseDTO>> {
        const response = await this.getLavoriRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLavoroByIdRaw(requestParameters: GetLavoroByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LavoriDettaglioResponseDTO>> {
        if (requestParameters['idLavoro'] == null) {
            throw new runtime.RequiredError(
                'idLavoro',
                'Required parameter "idLavoro" was null or undefined when calling getLavoroById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/{idLavoro}`.replace(`{${"idLavoro"}}`, encodeURIComponent(String(requestParameters['idLavoro']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LavoriDettaglioResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async getLavoroById(requestParameters: GetLavoroByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LavoriDettaglioResponseDTO> {
        const response = await this.getLavoroByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReportLavoratoMensileRaw(requestParameters: GetReportLavoratoMensileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportResponseDTO>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        if (requestParameters['idCliente'] != null) {
            queryParameters['idCliente'] = requestParameters['idCliente'];
        }

        if (requestParameters['idCommessa'] != null) {
            queryParameters['idCommessa'] = requestParameters['idCommessa'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/reportLavoratoMensile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async getReportLavoratoMensile(requestParameters: GetReportLavoratoMensileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportResponseDTO> {
        const response = await this.getReportLavoratoMensileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReportSpeseMensiliRaw(requestParameters: GetReportSpeseMensiliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportResponseDTO>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/reportSpeseMensili`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async getReportSpeseMensili(requestParameters: GetReportSpeseMensiliRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportResponseDTO> {
        const response = await this.getReportSpeseMensiliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSpeseByLavoroIdRaw(requestParameters: GetSpeseByLavoroIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LavoriDettaglioSpeseResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idLavoro'] != null) {
            queryParameters['idLavoro'] = requestParameters['idLavoro'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/speseByLavoroId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LavoriDettaglioSpeseResponseDTOFromJSON));
    }

    /**
     */
    async getSpeseByLavoroId(requestParameters: GetSpeseByLavoroIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LavoriDettaglioSpeseResponseDTO>> {
        const response = await this.getSpeseByLavoroIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTipiRimborsoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TipiRimborsoResponseDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/tipiRimborso`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TipiRimborsoResponseDTOFromJSON));
    }

    /**
     */
    async getTipiRimborso(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TipiRimborsoResponseDTO>> {
        const response = await this.getTipiRimborsoRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async setGiornataSmartworkingRaw(requestParameters: SetGiornataSmartworkingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/setGiornataSmartworking`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setGiornataSmartworking(requestParameters: SetGiornataSmartworkingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setGiornataSmartworkingRaw(requestParameters, initOverrides);
    }

    /**
     */
    async spesePrecedentiRaw(requestParameters: SpesePrecedentiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpesePrecedentiResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idCommessa'] != null) {
            queryParameters['idCommessa'] = requestParameters['idCommessa'];
        }

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['idTipoSpesa'] != null) {
            queryParameters['idTipoSpesa'] = requestParameters['idTipoSpesa'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/spesePrecedenti`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpesePrecedentiResponseDTOFromJSON));
    }

    /**
     */
    async spesePrecedenti(requestParameters: SpesePrecedentiRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpesePrecedentiResponseDTO>> {
        const response = await this.spesePrecedentiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadFileSpeseRaw(requestParameters: UploadFileSpeseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['idLavoro'] != null) {
            formParams.append('IdLavoro', requestParameters['idLavoro'] as any);
        }

        if (requestParameters['idTipoSpesa'] != null) {
            formParams.append('IdTipoSpesa', requestParameters['idTipoSpesa'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/api/Lavori/uploadFileSpese`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async uploadFileSpese(requestParameters: UploadFileSpeseRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadFileSpeseRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertLavoroRaw(requestParameters: UpsertLavoroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/upsertLavoro`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LavoriInsertDTOToJSON(requestParameters['lavoriInsertDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertLavoro(requestParameters: UpsertLavoroRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertLavoroRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertSpeseRaw(requestParameters: UpsertSpeseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['idLavoro'] != null) {
            queryParameters['idLavoro'] = requestParameters['idLavoro'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Lavori/upsertSpese`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['lavoriSpeseInsertDTO']!.map(LavoriSpeseInsertDTOToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertSpese(requestParameters: UpsertSpeseRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertSpeseRaw(requestParameters, initOverrides);
    }

}
